// Primary 1 Mathematics Data - 小學一年級數學數據
export const p1MathsData = {
  title: '小學一年級數學',
  description: '基礎數學概念學習，建立數感和基本運算能力',
  grade: 'P1',
  year: '小學一年級',
  
  topics: [
    {
      id: 'p1-1n1',
      code: '1N1',
      title: '20以內的數',
      description: '認識20以內的數，建立數感',
      objectives: [
        '認識1-20的數字',
        '理解數字的順序',
        '學會數數和點數',
        '建立基本的數感'
      ],
      sampleQuestions: [
        {
          id: 'p1-1n1-q1',
          question: '數一數，下面有多少個蘋果？',
          image: '🍎🍎🍎🍎🍎',
          answer: '5個',
          solution: '逐個點數：1, 2, 3, 4, 5，所以有5個蘋果。',
          difficulty: 'basic'
        },
        {
          id: 'p1-1n1-q2',
          question: '寫出15到20的數字。',
          answer: '15, 16, 17, 18, 19, 20',
          solution: '按順序寫出：15, 16, 17, 18, 19, 20',
          difficulty: 'basic'
        },
        {
          id: 'p1-1n1-q3',
          question: '在12和18之間有多少個數字？',
          answer: '5個',
          solution: '12和18之間的數字是：13, 14, 15, 16, 17，共5個。',
          difficulty: 'intermediate'
        },
        {
          id: 'p1-1n1-q4',
          question: '小明有8個糖果，小華有12個糖果，誰的糖果比較多？',
          answer: '小華',
          solution: '比較8和12：8 < 12，所以小華的糖果比較多。',
          difficulty: 'intermediate'
        },
        {
          id: 'p1-1n1-q5',
          question: '把下面的數字按從小到大的順序排列：19, 7, 15, 3, 11',
          answer: '3, 7, 11, 15, 19',
          solution: '比較數字大小：3 < 7 < 11 < 15 < 19',
          difficulty: 'intermediate'
        }
      ]
    },
    {
      id: 'p1-1n2',
      code: '1N2',
      title: '基本加法和減法',
      description: '學習20以內的基本加減法運算',
      objectives: [
        '理解加法的概念',
        '理解減法的概念',
        '學會20以內的加減法',
        '解決簡單的應用題'
      ],
      sampleQuestions: [
        {
          id: 'p1-1n2-q1',
          question: '計算：7 + 8 = ?',
          answer: '15',
          solution: '7 + 8 = 15\n可以用數數法：從7開始數8個：8, 9, 10, 11, 12, 13, 14, 15',
          difficulty: 'basic'
        },
        {
          id: 'p1-1n2-q2',
          question: '計算：16 - 9 = ?',
          answer: '7',
          solution: '16 - 9 = 7\n可以用倒數法：從16倒數9個：15, 14, 13, 12, 11, 10, 9, 8, 7',
          difficulty: 'basic'
        },
        {
          id: 'p1-1n2-q3',
          question: '小明有5個蘋果，媽媽又給他3個，現在小明有多少個蘋果？',
          answer: '8個',
          solution: '5 + 3 = 8\n小明原本有5個，加上媽媽給的3個，所以現在有8個蘋果。',
          difficulty: 'intermediate'
        },
        {
          id: 'p1-1n2-q4',
          question: '小華有12個糖果，吃了4個，還剩下多少個？',
          answer: '8個',
          solution: '12 - 4 = 8\n小華原本有12個，吃掉4個，所以還剩下8個糖果。',
          difficulty: 'intermediate'
        },
        {
          id: 'p1-1n2-q5',
          question: '計算：9 + 6 - 3 = ?',
          answer: '12',
          solution: '9 + 6 - 3 = 15 - 3 = 12\n先算加法：9 + 6 = 15，再算減法：15 - 3 = 12',
          difficulty: 'advanced'
        }
      ]
    },
    {
      id: 'p1-1n3',
      code: '1N3',
      title: '100以內的數',
      description: '認識100以內的數，理解十位和個位',
      objectives: [
        '認識100以內的數字',
        '理解十位和個位的概念',
        '學會讀寫兩位數',
        '比較100以內數字的大小'
      ],
      sampleQuestions: [
        {
          id: 'p1-1n3-q1',
          question: '寫出數字：二十三',
          answer: '23',
          solution: '二十三 = 20 + 3 = 23\n二十表示2個十，三表示3個一。',
          difficulty: 'basic'
        },
        {
          id: 'p1-1n3-q2',
          question: '讀出數字：45',
          answer: '四十五',
          solution: '45 = 40 + 5\n4在十位表示四十，5在個位表示五，所以是四十五。',
          difficulty: 'basic'
        },
        {
          id: 'p1-1n3-q3',
          question: '比較大小：67 和 76',
          answer: '67 < 76',
          solution: '比較十位：6 < 7，所以67 < 76\n即使個位7 > 6，但十位決定大小。',
          difficulty: 'intermediate'
        },
        {
          id: 'p1-1n3-q4',
          question: '在50到60之間有多少個數字？',
          answer: '9個',
          solution: '50到60之間的數字是：51, 52, 53, 54, 55, 56, 57, 58, 59，共9個。',
          difficulty: 'intermediate'
        },
        {
          id: 'p1-1n3-q5',
          question: '寫出比89大1的數字。',
          answer: '90',
          solution: '89 + 1 = 90\n89的個位是9，加1後變成10，進位到十位，所以是90。',
          difficulty: 'advanced'
        }
      ]
    },
    {
      id: 'p1-1n4',
      code: '1N4',
      title: '加法和減法(一)',
      description: '學習100以內的基本加減法',
      objectives: [
        '學會100以內的加法',
        '學會100以內的減法',
        '理解進位和退位的概念',
        '解決簡單的應用題'
      ],
      sampleQuestions: [
        {
          id: 'p1-1n4-q1',
          question: '計算：25 + 37 = ?',
          answer: '62',
          solution: '25 + 37 = 62\n個位：5 + 7 = 12，寫2進1\n十位：2 + 3 + 1 = 6',
          difficulty: 'basic'
        },
        {
          id: 'p1-1n4-q2',
          question: '計算：68 - 29 = ?',
          answer: '39',
          solution: '68 - 29 = 39\n個位：8 - 9不夠，向十位借1，18 - 9 = 9\n十位：6 - 1 - 2 = 3',
          difficulty: 'basic'
        },
        {
          id: 'p1-1n4-q3',
          question: '小明有45元，買了一本書花了28元，還剩下多少元？',
          answer: '17元',
          solution: '45 - 28 = 17\n小明原本有45元，花了28元，所以還剩下17元。',
          difficulty: 'intermediate'
        },
        {
          id: 'p1-1n4-q4',
          question: '計算：56 + 24 + 18 = ?',
          answer: '98',
          solution: '56 + 24 + 18 = 98\n先算：56 + 24 = 80\n再算：80 + 18 = 98',
          difficulty: 'intermediate'
        },
        {
          id: 'p1-1n4-q5',
          question: '小華有73個糖果，給了小明25個，又給了小紅18個，還剩下多少個？',
          answer: '30個',
          solution: '73 - 25 - 18 = 30\n先算：73 - 25 = 48\n再算：48 - 18 = 30',
          difficulty: 'advanced'
        }
      ]
    },
    {
      id: 'p1-1m1',
      code: '1M1',
      title: '長度和距離(一)',
      description: '認識長度的概念和基本測量',
      objectives: [
        '認識長度的概念',
        '學會比較物體的長短',
        '認識厘米(cm)單位',
        '學會簡單的長度測量'
      ],
      sampleQuestions: [
        {
          id: 'p1-1m1-q1',
          question: '比較下面兩條線的長短：\n線A：████████\n線B：████████████',
          answer: '線B比較長',
          solution: '線A有8個單位，線B有12個單位\n12 > 8，所以線B比較長。',
          difficulty: 'basic'
        },
        {
          id: 'p1-1m1-q2',
          question: '用厘米尺量度一支鉛筆的長度。',
          answer: '約15厘米',
          solution: '將鉛筆放在厘米尺上，從0開始量度到鉛筆的末端，讀出長度。',
          difficulty: 'basic'
        },
        {
          id: 'p1-1m1-q3',
          question: '小明身高120厘米，小華身高115厘米，誰比較高？',
          answer: '小明',
          solution: '120 > 115，所以小明比較高。',
          difficulty: 'intermediate'
        },
        {
          id: 'p1-1m1-q4',
          question: '一條繩子長25厘米，剪掉8厘米，還剩下多少厘米？',
          answer: '17厘米',
          solution: '25 - 8 = 17\n原本25厘米，剪掉8厘米，所以還剩下17厘米。',
          difficulty: 'intermediate'
        },
        {
          id: 'p1-1m1-q5',
          question: '三根木棒分別長12厘米、15厘米和18厘米，最長的是哪一根？',
          answer: '18厘米的那一根',
          solution: '比較長度：12 < 15 < 18\n所以18厘米的那一根最長。',
          difficulty: 'advanced'
        }
      ]
    },
    {
      id: 'p1-1m2',
      code: '1M2',
      title: '貨幣(一)',
      description: '認識港幣的基本單位',
      objectives: [
        '認識港幣的硬幣和紙幣',
        '理解元、角的概念',
        '學會簡單的貨幣計算',
        '解決簡單的購物問題'
      ],
      sampleQuestions: [
        {
          id: 'p1-1m2-q1',
          question: '1元等於多少角？',
          answer: '10角',
          solution: '1元 = 10角\n這是港幣的基本換算關係。',
          difficulty: 'basic'
        },
        {
          id: 'p1-1m2-q2',
          question: '5角 + 3角 = ?',
          answer: '8角',
          solution: '5角 + 3角 = 8角\n直接相加即可。',
          difficulty: 'basic'
        },
        {
          id: 'p1-1m2-q3',
          question: '一個蘋果賣2元5角，小明有5元，買了兩個蘋果，還剩下多少錢？',
          answer: '0元',
          solution: '兩個蘋果：2元5角 × 2 = 5元\n5元 - 5元 = 0元\n所以還剩下0元。',
          difficulty: 'intermediate'
        },
        {
          id: 'p1-1m2-q4',
          question: '小華有3元2角，買了一本書花了2元8角，還剩下多少錢？',
          answer: '4角',
          solution: '3元2角 - 2元8角 = 4角\n3元2角 = 32角，2元8角 = 28角\n32 - 28 = 4角',
          difficulty: 'intermediate'
        },
        {
          id: 'p1-1m2-q5',
          question: '一包糖果賣1元5角，小明買了3包，一共要付多少錢？',
          answer: '4元5角',
          solution: '1元5角 × 3 = 4元5角\n1元5角 = 15角\n15 × 3 = 45角 = 4元5角',
          difficulty: 'advanced'
        }
      ]
    },
    {
      id: 'p1-1m3',
      code: '1M3',
      title: '長度和距離(二)',
      description: '進一步學習長度概念和測量',
      objectives: [
        '學會用不同單位測量長度',
        '理解長度的估算',
        '學會長度的加減法',
        '解決長度相關的應用題'
      ],
      sampleQuestions: [
        {
          id: 'p1-1m3-q1',
          question: '一條繩子長30厘米，另一條繩子長25厘米，兩條繩子接起來有多長？',
          answer: '55厘米',
          solution: '30 + 25 = 55\n將兩條繩子的長度相加即可。',
          difficulty: 'basic'
        },
        {
          id: 'p1-1m3-q2',
          question: '小明走路的步長是50厘米，走了10步，一共走了多遠？',
          answer: '500厘米',
          solution: '50 × 10 = 500\n每步50厘米，走10步，所以一共走了500厘米。',
          difficulty: 'intermediate'
        },
        {
          id: 'p1-1m3-q3',
          question: '一條繩子長100厘米，剪成3段，每段長度相等，每段有多長？',
          answer: '約33厘米',
          solution: '100 ÷ 3 ≈ 33.33\n100厘米分成3等份，每份約33厘米。',
          difficulty: 'intermediate'
        },
        {
          id: 'p1-1m3-q4',
          question: '小華的身高是120厘米，比小明高15厘米，小明身高多少？',
          answer: '105厘米',
          solution: '120 - 15 = 105\n小華比小明高15厘米，所以小明身高105厘米。',
          difficulty: 'intermediate'
        },
        {
          id: 'p1-1m3-q5',
          question: '三根木棒分別長18厘米、22厘米和25厘米，最長的和最短的相差多少厘米？',
          answer: '7厘米',
          solution: '最長：25厘米，最短：18厘米\n25 - 18 = 7\n相差7厘米。',
          difficulty: 'advanced'
        }
      ]
    },
    {
      id: 'p1-1m4',
      code: '1M4',
      title: '時間(一)',
      description: '認識時間的基本概念',
      objectives: [
        '認識時鐘的基本結構',
        '學會讀整點時間',
        '理解上午和下午的概念',
        '學會簡單的時間計算'
      ],
      sampleQuestions: [
        {
          id: 'p1-1m4-q1',
          question: '時鐘顯示3點，用數字表示是幾點？',
          answer: '3:00',
          solution: '3點用數字表示是3:00\n時針指向3，分針指向12。',
          difficulty: 'basic'
        },
        {
          id: 'p1-1m4-q2',
          question: '上午8點到下午2點，經過了多少小時？',
          answer: '6小時',
          solution: '上午8點到下午2點\n8點到12點：4小時\n12點到2點：2小時\n4 + 2 = 6小時',
          difficulty: 'intermediate'
        },
        {
          id: 'p1-1m4-q3',
          question: '小明早上7點起床，晚上9點睡覺，他一天醒著多少小時？',
          answer: '14小時',
          solution: '早上7點到晚上9點\n7點到12點：5小時\n12點到9點：9小時\n5 + 9 = 14小時',
          difficulty: 'intermediate'
        },
        {
          id: 'p1-1m4-q4',
          question: '小華下午3點開始做功課，做了2小時，幾點做完？',
          answer: '下午5點',
          solution: '下午3點 + 2小時 = 下午5點\n3 + 2 = 5',
          difficulty: 'intermediate'
        },
        {
          id: 'p1-1m4-q5',
          question: '上午10點到下午4點，中間經過了多少小時？',
          answer: '6小時',
          solution: '上午10點到下午4點\n10點到12點：2小時\n12點到4點：4小時\n2 + 4 = 6小時',
          difficulty: 'advanced'
        }
      ]
    },
    {
      id: 'p1-1s1',
      code: '1S1',
      title: '立體圖形(一)',
      description: '認識基本的立體圖形',
      objectives: [
        '認識正方體、長方體、圓柱體',
        '學會識別立體圖形的特徵',
        '理解立體圖形的基本性質',
        '學會簡單的立體圖形分類'
      ],
      sampleQuestions: [
        {
          id: 'p1-1s1-q1',
          question: '一個正方體有多少個面？',
          answer: '6個面',
          solution: '正方體有6個面，都是正方形，大小相等。',
          difficulty: 'basic'
        },
        {
          id: 'p1-1s1-q2',
          question: '一個長方體有多少個頂點？',
          answer: '8個頂點',
          solution: '長方體有8個頂點，12條邊，6個面。',
          difficulty: 'basic'
        },
        {
          id: 'p1-1s1-q3',
          question: '圓柱體的兩個底面是什麼形狀？',
          answer: '圓形',
          solution: '圓柱體的上下兩個底面都是圓形，大小相等。',
          difficulty: 'intermediate'
        },
        {
          id: 'p1-1s1-q4',
          question: '一個正方體的所有邊長都相等嗎？',
          answer: '是',
          solution: '正方體的所有邊長都相等，所有面都是正方形。',
          difficulty: 'intermediate'
        },
        {
          id: 'p1-1s1-q5',
          question: '長方體和正方體有什麼不同？',
          answer: '邊長不同',
          solution: '正方體的所有邊長都相等，長方體的邊長不一定相等。',
          difficulty: 'advanced'
        }
      ]
    },
    {
      id: 'p1-1s2',
      code: '1S2',
      title: '平面圖形',
      description: '認識基本的平面圖形',
      objectives: [
        '認識正方形、長方形、三角形、圓形',
        '學會識別平面圖形的特徵',
        '理解平面圖形的基本性質',
        '學會簡單的圖形分類'
      ],
      sampleQuestions: [
        {
          id: 'p1-1s2-q1',
          question: '正方形有多少條邊？',
          answer: '4條邊',
          solution: '正方形有4條邊，所有邊長相等，所有角都是直角。',
          difficulty: 'basic'
        },
        {
          id: 'p1-1s2-q2',
          question: '長方形有多少個角？',
          answer: '4個角',
          solution: '長方形有4個角，都是直角，對邊相等。',
          difficulty: 'basic'
        },
        {
          id: 'p1-1s2-q3',
          question: '三角形有多少條邊？',
          answer: '3條邊',
          solution: '三角形有3條邊，3個角，內角和是180度。',
          difficulty: 'intermediate'
        },
        {
          id: 'p1-1s2-q4',
          question: '圓形有沒有角？',
          answer: '沒有角',
          solution: '圓形沒有角，是一條封閉的曲線。',
          difficulty: 'intermediate'
        },
        {
          id: 'p1-1s2-q5',
          question: '正方形和長方形有什麼相同點？',
          answer: '都有4個直角',
          solution: '正方形和長方形都有4個直角，都是四邊形。',
          difficulty: 'advanced'
        }
      ]
    },
    {
      id: 'p1-1s3',
      code: '1S3',
      title: '方向和位置(一)',
      description: '認識基本的方向概念',
      objectives: [
        '認識上下、左右、前後',
        '學會描述物體的位置',
        '理解相對位置的概念',
        '學會簡單的方向指示'
      ],
      sampleQuestions: [
        {
          id: 'p1-1s3-q1',
          question: '小明的左邊是誰？',
          answer: '需要看具體情況',
          solution: '要根據小明的面向來確定左右方向。',
          difficulty: 'basic'
        },
        {
          id: 'p1-1s3-q2',
          question: '書桌在椅子的什麼位置？',
          answer: '前面',
          solution: '通常書桌在椅子的前面，方便使用。',
          difficulty: 'basic'
        },
        {
          id: 'p1-1s3-q3',
          question: '小明在小華的前面，小華在小明的什麼位置？',
          answer: '後面',
          solution: '如果小明在小華前面，那麼小華就在小明後面。',
          difficulty: 'intermediate'
        },
        {
          id: 'p1-1s3-q4',
          question: '教室的門在窗戶的左邊，窗戶在門的什麼位置？',
          answer: '右邊',
          solution: '如果門在窗戶左邊，那麼窗戶就在門的右邊。',
          difficulty: 'intermediate'
        },
        {
          id: 'p1-1s3-q5',
          question: '描述小明在教室裡的位置。',
          answer: '需要具體信息',
          solution: '需要知道小明相對於其他物體的位置關係。',
          difficulty: 'advanced'
        }
      ]
    },
    {
      id: 'p1-1f1',
      code: '1F1',
      title: '探索與研究',
      description: '通過活動發現數學規律',
      objectives: [
        '培養數學思維能力',
        '學會觀察和發現規律',
        '提高解決問題的能力',
        '培養探索精神'
      ],
      sampleQuestions: [
        {
          id: 'p1-1f1-q1',
          question: '觀察數字：2, 4, 6, 8, 10，下一個數字是什麼？',
          answer: '12',
          solution: '每個數字都比前一個多2，所以下一個是10 + 2 = 12。',
          difficulty: 'basic'
        },
        {
          id: 'p1-1f1-q2',
          question: '用3個相同的正方形可以拼成什麼圖形？',
          answer: '長方形',
          solution: '3個正方形可以拼成一個長方形，長是寬的3倍。',
          difficulty: 'intermediate'
        },
        {
          id: 'p1-1f1-q3',
          question: '小明有5個蘋果，每次吃1個，可以吃幾天？',
          answer: '5天',
          solution: '5個蘋果，每天吃1個，可以吃5天。',
          difficulty: 'intermediate'
        },
        {
          id: 'p1-1f1-q4',
          question: '找出規律：1, 3, 5, 7, ?',
          answer: '9',
          solution: '每個數字都比前一個多2，所以下一個是7 + 2 = 9。',
          difficulty: 'intermediate'
        },
        {
          id: 'p1-1f1-q5',
          question: '用4根相同長度的木棒可以拼成什麼圖形？',
          answer: '正方形或長方形',
          solution: '4根相同長度的木棒可以拼成正方形，也可以拼成長方形。',
          difficulty: 'advanced'
        }
      ]
    }
  ]
}; 